(() => {

    // Update cart recommendation on cart updates
    document.addEventListener("cart:change", () => {
    	setTimeout(() => {
    		document.documentElement.dispatchEvent(new CustomEvent("cart:refresh",  {
    			bubbles: true,
    			detail: {
    				show_cart_note: false
    			}
    		}));
    	}, 300);
    });

    const notifyIcon = document.querySelector('.p42_notify_icon');
    const notifyItem = notifyIcon ? notifyIcon.closest('.p42_notify_item') : null;
    const updateNotifyIcon = () => {
      if (!notifyIcon || !notifyItem) {
        return;
      }

      const shouldShow = 'Notification' in window && Notification.permission === 'default';
      notifyItem.hidden = !shouldShow;
    };

    if (notifyIcon) {
      notifyIcon.addEventListener('click', () => {
        if (!('Notification' in window) || Notification.permission !== 'default') {
          updateNotifyIcon();
          return;
        }

        const permissionRequest = Notification.requestPermission();

        if (permissionRequest && typeof permissionRequest.then === 'function') {
          permissionRequest.then(updateNotifyIcon).catch(updateNotifyIcon);
        } else {
          updateNotifyIcon();
        }
      });

      updateNotifyIcon();
    }

  // Testimonial shuffle
  var testimonial_list = document.querySelector(".testimonial-list");
  if (testimonial_list) {
    var testimonial_divs = Array.from(testimonial_list.querySelectorAll(".testimonial"));
    for (var i = testimonial_divs.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      [testimonial_divs[i], testimonial_divs[j]] = [testimonial_divs[j], testimonial_divs[i]];
    }
  
    // Limit the divs to only 3
    testimonial_divs = testimonial_divs.slice(0, 3);
  
    // Clear the testimonial_list
    while (testimonial_list.firstChild) {
      testimonial_list.removeChild(testimonial_list.firstChild);
    }
  
    // Append the first 3 shuffled divs back to the testimonial_list
    testimonial_divs.forEach(function (div) {
      testimonial_list.appendChild(div);
    });
  }
  
  
})();
